<div class="base-container">
  @let runTimesValue = runTimes();

  <div class="flex-flow-wrapper">
    <ng-container *ngTemplateOutlet="cardMap"></ng-container>
    <ng-container *ngTemplateOutlet="cardInfoBox"></ng-container>
  </div>

  <ng-template #cardInfoBox>
    <!-- (Infobox) -->
    <mat-card appearance="outlined" class="model-info-card">
      <mat-card-header>
        <fa-icon mat-card-avatar [icon]="['far', 'globe']" size="2x"></fa-icon>
        <mat-card-title>{{ 'PRODUCT.MODEL.TITLE' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="modelForm">
          <!-- Model Select -->
          <mat-form-field appearance="fill" class="parameter-select">
            <mat-label>
              {{ 'PRODUCT.MODEL.SELECT_MODEL' | translate }}
            </mat-label>
            <mat-select
              formControlName="model"
              (selectionChange)="onChangeModel($event)">
              @for (model of models(); track $index) {
                <mat-option [value]="model">
                  <span [translate]="'PRODUCT.MODEL.MODELS.' + model"></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />
          <!-- Region Select -->
          <mat-form-field appearance="fill" class="parameter-select">
            <mat-label>
              {{ 'PRODUCT.MODEL.SELECT_REGION' | translate }}
            </mat-label>
            <mat-select
              formControlName="region"
              (selectionChange)="onChangeRegion($event)">
              @for (region of regions(); track $index) {
                <mat-option [value]="region">
                  <span [translate]="'PRODUCT.MODEL.REGIONS.' + region"></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />

          <!-- Model Run Select -->
          <mat-form-field appearance="fill" class="parameter-select">
            <mat-label>
              {{ 'PRODUCT.MODEL.SELECT_MODEL_RUN' | translate }}
            </mat-label>
            <mat-select
              formControlName="runValue"
              (selectionChange)="onChangeRun($event)">
              @for (runTime of runTimesValue; track $index) {
                <mat-option [value]="runTime.toISOString()">
                  {{
                    runTime
                      | datex
                        : 'DD.MM.YYYY HH:00'
                        : undefined
                        : languageService.langSignal()
                  }}z
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />

          <!-- Parameter Select -->
          <mat-form-field appearance="fill" class="parameter-select">
            <mat-label>
              {{ 'PRODUCT.MODEL.SELECT_PARAMETER' | translate }}
            </mat-label>
            <mat-select
              formControlName="parameter"
              (selectionChange)="onChangeParameter($event)">
              @for (
                parameter of modelDetails()[selectedModel()];
                track $index
              ) {
                <mat-option [value]="parameter">
                  <span
                    [translate]="
                      'PRODUCT.MODEL.PARAMETERS.' + parameter
                    "></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #cardMap>
    <!-- Left Card (Map) -->
    <mat-card appearance="outlined" class="model-map-card">
      <!-- Slider -->
      <mat-card-header>
        <fa-icon mat-card-avatar [icon]="['far', 'globe']" size="2x"></fa-icon>
        @if (mapDtg.isValid()) {
          <mat-card-title>
            {{ 'PRODUCT.MODEL.PARAMETERS.' + selectedParameter() | translate }}
            - {{ 'PRODUCT.MODEL.MODELS.' + selectedModel() | translate }} -
            {{ mapDtg | datex: 'dddd DD.MM.YYYY HH:mm' }}
          </mat-card-title>
        }
        <mat-card-subtitle>
          {{ 'PRODUCT.MODEL.TITLE' | translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (runTimesValue && runTimesValue.length > 0) {
          <div class="slider-bar">
            <div class="controls">
              @if (!animationIsRunning()) {
                <button mat-icon-button class="control" (click)="onPlay()">
                  <fa-icon [icon]="['far', 'play']" size="lg"></fa-icon>
                </button>
              } @else {
                <button mat-icon-button class="control" (click)="onPause()">
                  <fa-icon [icon]="['far', 'pause']" size="lg"></fa-icon>
                </button>
              }
            </div>
            <div class="slider">
              <ngx-slider
                [(value)]="sliderDate"
                [options]="sliderOptions()"
                (userChange)="onSliderChange($event)"></ngx-slider>
            </div>
          </div>
        }
        <mat-divider></mat-divider>
        <div class="map" id="map"></div>

        @let selectedParameterValue = selectedParameter();
        @if (selectedParameterValue === 'TMP2m') {
          <table class="tt">
            <tr>
              <td>-30</td>
              <td>-28</td>
              <td>-26</td>
              <td>-24</td>
              <td>-22</td>
              <td>-20</td>
              <td>-18</td>
              <td>-16</td>
              <td>-14</td>
              <td>-12</td>
              <td>-10</td>
              <td>-8</td>
              <td>-6</td>
              <td>-4</td>
              <td>-2</td>
              <td>0</td>
              <td>2</td>
              <td>4</td>
              <td>6</td>
              <td>8</td>
              <td>10</td>
              <td>12</td>
              <td>14</td>
              <td>16</td>
              <td>18</td>
              <td>20</td>
              <td>22</td>
              <td>24</td>
              <td>26</td>
              <td>28</td>
              <td>30</td>
              <td>32</td>
              <td>34</td>
              <td>36</td>
              <td>&deg;C</td>
            </tr>
            <tr>
              <td class="tt1"></td>
              <td class="tt2"></td>
              <td class="tt3"></td>
              <td class="tt4"></td>
              <td class="tt5"></td>
              <td class="tt6"></td>
              <td class="tt7"></td>
              <td class="tt8"></td>
              <td class="tt9"></td>
              <td class="tt10"></td>
              <td class="tt11"></td>
              <td class="tt12"></td>
              <td class="tt13"></td>
              <td class="tt14"></td>
              <td class="tt15"></td>
              <td class="tt16"></td>
              <td class="tt17"></td>
              <td class="tt18"></td>
              <td class="tt19"></td>
              <td class="tt20"></td>
              <td class="tt21"></td>
              <td class="tt22"></td>
              <td class="tt23"></td>
              <td class="tt24"></td>
              <td class="tt25"></td>
              <td class="tt26"></td>
              <td class="tt27"></td>
              <td class="tt28"></td>
              <td class="tt29"></td>
              <td class="tt30"></td>
              <td class="tt31"></td>
              <td class="tt32"></td>
              <td class="tt33"></td>
              <td class="tt34"></td>
              <td class="tt35"></td>
            </tr>
          </table>
        }

        @if (
          selectedParameterValue === 'PRCUM' ||
          selectedParameterValue === 'SD' ||
          selectedParameterValue === 'SF'
        ) {
          <table class="tt">
            <tr>
              <td>0.1</td>
              <td>1</td>
              @if (selectedParameterValue === 'SF') {
                <td>3</td>
              }
              <td>5</td>
              <td>10</td>
              <td>20</td>
              <td>50</td>
              @if (selectedParameterValue === 'PRCUM') {
                <td>mm</td>
              }
              @if (
                selectedParameterValue === 'SD' ||
                selectedParameterValue === 'SF'
              ) {
                <td>cm</td>
              }
            </tr>
            <tr>
              <td class="rr1"></td>
              <td class="rr2"></td>
              @if (selectedParameterValue === 'SF') {
                <td class="sf3"></td>
              }
              <td class="rr3"></td>
              <td class="rr4"></td>
              <td class="rr5"></td>
              <td class="rr6"></td>
              <td class="rr7"></td>
            </tr>
          </table>
        }

        @if (selectedParameterValue === 'Wind') {
          <table class="tt">
            <tr>
              <td>4</td>
              <td>5</td>
              <td>6</td>
              <td>7</td>
              <td>8</td>
              <td>9</td>
              <td>10</td>
              <td>11</td>
              <td>12</td>
              <td>Bft</td>
            </tr>
            <tr>
              <td class="wind1"></td>
              <td class="wind2"></td>
              <td class="wind3"></td>
              <td class="wind4"></td>
              <td class="wind5"></td>
              <td class="wind6"></td>
              <td class="wind7"></td>
              <td class="wind8"></td>
              <td class="wind9"></td>
              <td class="wind10"></td>
            </tr>
          </table>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>

  <form [formGroup]="modelForm" *ngIf="false">
    <!-- Panel -->
    <div class="panel">
      <!-- Model Select -->
      <mat-form-field appearance="fill" class="model-select">
        <mat-label>
          {{ 'PRODUCT.MODEL.SELECT_MODEL' | translate }}
        </mat-label>
        <mat-select
          formControlName="model"
          (selectionChange)="onChangeModel($event)">
          @for (model of models(); track $index) {
            <mat-option [value]="model">
              <span [translate]="'PRODUCT.MODEL.MODELS.' + model"></span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Region Select -->
      <mat-form-field appearance="fill" class="region-select">
        <mat-label>
          {{ 'PRODUCT.MODEL.SELECT_REGION' | translate }}
        </mat-label>
        <mat-select
          formControlName="region"
          (selectionChange)="onChangeRegion($event)">
          @for (region of regions(); track $index) {
            <mat-option [value]="region">
              <span [translate]="'PRODUCT.MODEL.REGIONS.' + region"></span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Model Run Select -->
      <mat-form-field appearance="fill" class="run-select">
        <mat-label>
          {{ 'PRODUCT.MODEL.SELECT_MODEL_RUN' | translate }}
        </mat-label>
        <mat-select
          formControlName="runValue"
          (selectionChange)="onChangeRun($event)">
          @for (runTime of runTimesValue; track $index) {
            <mat-option [value]="runTime.toISOString()">
              {{
                runTime
                  | datex
                    : 'DD.MM.YYYY HH:00'
                    : undefined
                    : languageService.langSignal()
              }}z
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Parameter Select -->
      <mat-form-field appearance="fill" class="parameter-select">
        <mat-label>
          {{ 'PRODUCT.MODEL.SELECT_PARAMETER' | translate }}
        </mat-label>
        <mat-select
          formControlName="parameter"
          (selectionChange)="onChangeParameter($event)">
          @for (parameter of modelDetails()[selectedModel()]; track $index) {
            <mat-option [value]="parameter">
              <span
                [translate]="'PRODUCT.MODEL.PARAMETERS.' + parameter"></span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <mat-card appearance="outlined" class="map-card" *ngIf="false">
    <!-- Slider & Map Bereich (Unverändert) -->
    @if (runTimesValue && runTimesValue.length > 0) {
      <div class="slider-bar">
        <div class="controls">
          @if (!animationIsRunning()) {
            <button mat-icon-button class="control" (click)="onPlay()">
              <fa-icon [icon]="['far', 'play']" size="lg"></fa-icon>
            </button>
          } @else {
            <button mat-icon-button class="control" (click)="onPause()">
              <fa-icon [icon]="['far', 'pause']" size="lg"></fa-icon>
            </button>
          }
        </div>
        <div class="slider">
          <ngx-slider
            [(value)]="sliderDate"
            [options]="sliderOptions()"
            (userChange)="onSliderChange($event)"></ngx-slider>
        </div>
      </div>
    }
    <mat-divider></mat-divider>
    <div class="map" id="map"></div>

    @let selectedParameterValue1 = selectedParameter();
    <div class="map-legend-wrapper">
      <!-- FALL 1: TEMPERATUR LEGENDE (TMP2m) -->
      @if (selectedParameterValue1 === 'TMP2m') {
        <table class="map-legend-table legend-type--temperature">
          <tr class="legend-text-row">
            <td>-30</td>
            <td>-28</td>
            <td>-26</td>
            <td>-24</td>
            <td>-22</td>
            <td>-20</td>
            <td>-18</td>
            <td>-16</td>
            <td>-14</td>
            <td>-12</td>
            <td>-10</td>
            <td>-8</td>
            <td>-6</td>
            <td>-4</td>
            <td>-2</td>
            <td>0</td>
            <td>2</td>
            <td>4</td>
            <td>6</td>
            <td>8</td>
            <td>10</td>
            <td>12</td>
            <td>14</td>
            <td>16</td>
            <td>18</td>
            <td>20</td>
            <td>22</td>
            <td>24</td>
            <td>26</td>
            <td>28</td>
            <td>30</td>
            <td>32</td>
            <td>34</td>
            <td>36</td>
            <td class="legend-unit-cell">°C</td>
          </tr>
          <tr class="legend-color-bar-row">
            <td class="tt1"></td>
            <td class="tt2"></td>
            <td class="tt3"></td>
            <td class="tt4"></td>
            <td class="tt5"></td>
            <td class="tt6"></td>
            <td class="tt7"></td>
            <td class="tt8"></td>
            <td class="tt9"></td>
            <td class="tt10"></td>
            <td class="tt11"></td>
            <td class="tt12"></td>
            <td class="tt13"></td>
            <td class="tt14"></td>
            <td class="tt15"></td>
            <td class="tt16"></td>
            <td class="tt17"></td>
            <td class="tt18"></td>
            <td class="tt19"></td>
            <td class="tt20"></td>
            <td class="tt21"></td>
            <td class="tt22"></td>
            <td class="tt23"></td>
            <td class="tt24"></td>
            <td class="tt25"></td>
            <td class="tt26"></td>
            <td class="tt27"></td>
            <td class="tt28"></td>
            <td class="tt29"></td>
            <td class="tt30"></td>
            <td class="tt31"></td>
            <td class="tt32"></td>
            <td class="tt33"></td>
            <td class="tt34"></td>
            <td class="tt35"></td>
          </tr>
        </table>
      }

      <!-- FALL 2: NIEDERSCHLAG / SCHNEE LEGENDE (PRCUM, SD, SF) -->
      @if (
        selectedParameterValue1 === 'PRCUM' ||
        selectedParameterValue1 === 'SD' ||
        selectedParameterValue1 === 'SF'
      ) {
        <table class="map-legend-table legend-type--precipitation">
          <tr class="legend-text-row">
            <td>0.1</td>
            <td>1</td>
            @if (selectedParameterValue1 === 'SF') {
              <td>3</td>
            }
            <td>5</td>
            <td>10</td>
            <td>20</td>
            <td>50</td>
            <td class="legend-unit-cell">
              @if (selectedParameterValue1 === 'PRCUM') {
                <span>mm</span>
              }
              @if (
                selectedParameterValue1 === 'SD' ||
                selectedParameterValue1 === 'SF'
              ) {
                <span>cm</span>
              }
            </td>
          </tr>
          <tr class="legend-color-bar-row">
            <td class="rr1"></td>
            <td class="rr2"></td>
            @if (selectedParameterValue1 === 'SF') {
              <td class="sf3"></td>
            }
            <td class="rr3"></td>
            <td class="rr4"></td>
            <td class="rr5"></td>
            <td class="rr6"></td>
            <td class="rr7"></td>
          </tr>
        </table>
      }

      <!-- FALL 3: WINDSTÄRKE LEGENDE (Wind) -->
      @if (selectedParameterValue1 === 'Wind') {
        <table class="map-legend-table legend-type--wind">
          <tr class="legend-text-row">
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>9</td>
            <td>10</td>
            <td>11</td>
            <td>12</td>
            <td class="legend-unit-cell">Bft</td>
          </tr>
          <tr class="legend-color-bar-row">
            <td class="wind1"></td>
            <td class="wind2"></td>
            <td class="wind3"></td>
            <td class="wind4"></td>
            <td class="wind5"></td>
            <td class="wind6"></td>
            <td class="wind7"></td>
            <td class="wind8"></td>
            <td class="wind9"></td>
            <td class="wind10"></td>
          </tr>
        </table>
      }
    </div>
  </mat-card>

  <!--<mat-card appearance="outlined" class="map-card" *ngIf="false">
    &lt;!&ndash; Slider &ndash;&gt;
    @if (runTimesValue && runTimesValue.length > 0) {
      <div class="slider-bar">
        <div class="controls">
          @if (!animationIsRunning()) {
            <button mat-icon-button class="control" (click)="onPlay()">
              <fa-icon [icon]="['far', 'play']" size="lg"></fa-icon>
            </button>
          } @else {
            <button mat-icon-button class="control" (click)="onPause()">
              <fa-icon [icon]="['far', 'pause']" size="lg"></fa-icon>
            </button>
          }
        </div>
        <div class="slider">
          <ngx-slider
            [(value)]="sliderDate"
            [options]="sliderOptions()"
            (userChange)="onSliderChange($event)"></ngx-slider>
        </div>
      </div>
    }
    <mat-divider></mat-divider>
    <div class="map" id="map"></div>

    @let selectedParameterValue1 = selectedParameter();
    @if (selectedParameterValue1 === 'TMP2m') {
      <table class="tt">
        <tr>
          <td>-30</td>
          <td>-28</td>
          <td>-26</td>
          <td>-24</td>
          <td>-22</td>
          <td>-20</td>
          <td>-18</td>
          <td>-16</td>
          <td>-14</td>
          <td>-12</td>
          <td>-10</td>
          <td>-8</td>
          <td>-6</td>
          <td>-4</td>
          <td>-2</td>
          <td>0</td>
          <td>2</td>
          <td>4</td>
          <td>6</td>
          <td>8</td>
          <td>10</td>
          <td>12</td>
          <td>14</td>
          <td>16</td>
          <td>18</td>
          <td>20</td>
          <td>22</td>
          <td>24</td>
          <td>26</td>
          <td>28</td>
          <td>30</td>
          <td>32</td>
          <td>34</td>
          <td>36</td>
          <td>&deg;C</td>
        </tr>
        <tr>
          <td class="tt1"></td>
          <td class="tt2"></td>
          <td class="tt3"></td>
          <td class="tt4"></td>
          <td class="tt5"></td>
          <td class="tt6"></td>
          <td class="tt7"></td>
          <td class="tt8"></td>
          <td class="tt9"></td>
          <td class="tt10"></td>
          <td class="tt11"></td>
          <td class="tt12"></td>
          <td class="tt13"></td>
          <td class="tt14"></td>
          <td class="tt15"></td>
          <td class="tt16"></td>
          <td class="tt17"></td>
          <td class="tt18"></td>
          <td class="tt19"></td>
          <td class="tt20"></td>
          <td class="tt21"></td>
          <td class="tt22"></td>
          <td class="tt23"></td>
          <td class="tt24"></td>
          <td class="tt25"></td>
          <td class="tt26"></td>
          <td class="tt27"></td>
          <td class="tt28"></td>
          <td class="tt29"></td>
          <td class="tt30"></td>
          <td class="tt31"></td>
          <td class="tt32"></td>
          <td class="tt33"></td>
          <td class="tt34"></td>
          <td class="tt35"></td>
        </tr>
      </table>
    }

    @if (
      selectedParameterValue1 === 'PRCUM' ||
      selectedParameterValue1 === 'SD' ||
      selectedParameterValue1 === 'SF'
    ) {
      <table class="tt">
        <tr>
          <td>0.1</td>
          <td>1</td>
          @if (selectedParameterValue1 === 'SF') {
            <td>3</td>
          }
          <td>5</td>
          <td>10</td>
          <td>20</td>
          <td>50</td>
          @if (selectedParameterValue1 === 'PRCUM') {
            <td>mm</td>
          }
          @if (
            selectedParameterValue1 === 'SD' || selectedParameterValue1 === 'SF'
          ) {
            <td>cm</td>
          }
        </tr>
        <tr>
          <td class="rr1"></td>
          <td class="rr2"></td>
          @if (selectedParameterValue1 === 'SF') {
            <td class="sf3"></td>
          }
          <td class="rr3"></td>
          <td class="rr4"></td>
          <td class="rr5"></td>
          <td class="rr6"></td>
          <td class="rr7"></td>
        </tr>
      </table>
    }

    @if (selectedParameterValue1 === 'Wind') {
      <table class="tt">
        <tr>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>Bft</td>
        </tr>
        <tr>
          <td class="wind1"></td>
          <td class="wind2"></td>
          <td class="wind3"></td>
          <td class="wind4"></td>
          <td class="wind5"></td>
          <td class="wind6"></td>
          <td class="wind7"></td>
          <td class="wind8"></td>
          <td class="wind9"></td>
          <td class="wind10"></td>
        </tr>
      </table>
    }
  </mat-card>-->
</div>
